<script setup>
import InvestmentProcessHeadline from '../InvestmentProcessHeadline.vue'
import InvestmentProcessWrapper from '../InvestmentProcessWrapper.vue'
import InvestmentProcessSteps from '../InvestmentProcessSteps.vue'
import {
    initializeInvestmentProcessNavigation,
    useInvestmentProcessNavigation,
} from '../../../utilities/account/useInvestmentProcessNavigation'
import StockInvestmentProcessAmount from './StockInvestmentProcessAmount.vue'
import StockInvestmentProcessLegal from './StockInvestmentProcessLegal.vue'
import StockInvestmentProcessSummary from './StockInvestmentProcessSummary.vue'
import StockInvestmentProcessPayment from './StockInvestmentProcessPayment.vue'
import NaturalProfileSidebarCard from '../sidebar/NaturalProfileSidebarCard.vue'
import { isLegalProfile, isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import LegalProfileSidebarCard from '../sidebar/LegalProfileSidebarCard.vue'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { i18n } from '../../../localization'
import CampaignSidebarCard from '../sidebar/CampaignSidebarCard.vue'
import { useNyalaCustomerVaultData } from '../../../utilities/account/useNyalaCustomerVaultData'
import InvestmentProcessStepsMobile from '../InvestmentProcessStepsMobile.vue'

const investmentProcessDataStore = useInvestmentProcessDataState()
const nyalaCustomerVaultDataStore = useNyalaCustomerVaultData()
const investmentProcessNavigationStore = useInvestmentProcessNavigation()

investmentProcessDataStore.loadPendingInvestment()
investmentProcessDataStore.$subscribe(investmentProcessDataStore.setPendingInvestment)

nyalaCustomerVaultDataStore.fetchVaultData()

const steps = [
    {
        name: 'investmentAmount',
        label: i18n.global.t('investment_process.investment_amount'),
        component: StockInvestmentProcessAmount,
    },
    {
        name: 'legal',
        label: i18n.global.t('investment_process.law_requirements'),
        component: StockInvestmentProcessLegal,
    },
    { name: 'summary', label: i18n.global.t('investment_process.summary'), component: StockInvestmentProcessSummary },
    { name: 'payment', label: i18n.global.t('investment_process.payment'), component: StockInvestmentProcessPayment },
]

initializeInvestmentProcessNavigation(steps)
</script>

<template>
    <InvestmentProcessWrapper>
        <template #header>
            <InvestmentProcessHeadline />
            <InvestmentProcessSteps />
            <InvestmentProcessStepsMobile />
        </template>
        <template #main>
            <component :is="investmentProcessNavigationStore.currentStep.component"></component>
        </template>
        <template #sidebar>
            <div class="space-y-6">
                <NaturalProfileSidebarCard v-if="isNaturalProfile()"></NaturalProfileSidebarCard>
                <LegalProfileSidebarCard v-if="isLegalProfile()"></LegalProfileSidebarCard>
                <CampaignSidebarCard></CampaignSidebarCard>
            </div>
        </template>
    </InvestmentProcessWrapper>
</template>

<style scoped></style>
